import { render, staticRenderFns } from "./AttributesReader.vue?vue&type=template&id=6faaae70"
import script from "./AttributesReader.vue?vue&type=script&lang=js"
export * from "./AttributesReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports